import {
  Box,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import TableCell from '../../components/TableCell';
import { getContractsHistory } from '../../redux/slices/contractsSlice';
import { RootState } from '../../redux/store';
import { convertSecondsToHHMMSS } from '../../helpers/time';

interface Props {
  userId?: string;
  scooterId?: string;
}

const ContractsHistoryContent = (props: Props) => {
  const { userId, scooterId } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { items: contracts, pages } = useSelector(
    (state: RootState) => state.contracts.history
  );

  const [page, setPage] = useState(1);

  useEffect(() => {
    if (userId || scooterId) {
      dispatch(
        getContractsHistory({
          userId,
          scooterId,
          page,
          limit: 20,
          active: false
        })
      );
    }
  }, [dispatch, userId, scooterId, page]);

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2} direction='column'>
        <Grid item overflow={'auto'}>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>{t('userModal.colClient')}</TableCell>
                  <TableCell>{t('userModal.phone')}</TableCell>
                  <TableCell>{t('userModal.colScooterNumber')}</TableCell>
                  <TableCell>{t('userModal.colTripStart')}</TableCell>
                  <TableCell>{t('userModal.colTripEnd')}</TableCell>
                  <TableCell>{t('userModal.colTimeRiding')}</TableCell>
                  <TableCell>{t('userModal.colTimePause')}</TableCell>
                  <TableCell>{t('userModal.colTimeReservation')}</TableCell>
                  <TableCell>{t('userModal.colTripDuration')}</TableCell>
                  <TableCell>{t('userModal.colDistance')}</TableCell>
                  <TableCell>{t('userModal.colCost')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contracts.map(contract => (
                  <TableRow key={contract._id}>
                    <TableCell>
                      {contract.user.lastName} {contract.user.firstName}{' '}
                      {contract.user.middleName}
                    </TableCell>
                    <TableCell>{contract.user.phone}</TableCell>
                    <TableCell>{contract.scooter?.name}</TableCell>
                    <TableCell>
                      {moment(contract.createdAt).format(
                        'DD MMM YYYY, HH:mm:ss'
                      )}
                    </TableCell>
                    <TableCell>
                      {moment(contract.closedDate).format(
                        'DD MMM YYYY, HH:mm:ss'
                      )}
                    </TableCell>
                    <TableCell>
                      {contract?.historyDetails?.normal?.duration
                        ? convertSecondsToHHMMSS(
                            contract?.historyDetails?.normal?.duration
                          )
                        : '00:00:00'}
                    </TableCell>
                    <TableCell>
                      {contract?.historyDetails?.pause?.duration
                        ? convertSecondsToHHMMSS(
                            contract?.historyDetails?.pause?.duration
                          )
                        : '00:00:00'}
                    </TableCell>
                    <TableCell>
                      {contract?.historyDetails?.reservation?.duration
                        ? convertSecondsToHHMMSS(
                            contract?.historyDetails?.reservation?.duration
                          )
                        : '00:00:00'}
                    </TableCell>
                    <TableCell>
                      {moment.utc(contract.period * 1000).format('mm:ss')}
                    </TableCell>
                    <TableCell>{contract.mileage}</TableCell>
                    <TableCell>{contract.sum}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item>
          <Pagination
            count={pages}
            onChange={(event, nextPage) => setPage(nextPage)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContractsHistoryContent;
